"use strict";
// Copyright © 2021 Move Closer
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerComponent = void 0;
const vue_1 = __importDefault(require("vue"));
/**
 * Registers the passed-in Vue component in the app.
 *
 * @param component - The Vue component to register.
 * @param [name] - The name under which the component should be available in the `<template>` section.
 *   If not specified, component will be registered under the identifier from the `component.name` property.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.registerComponent = (component, name) => {
    /**
     * The identifier under which the component should be registered.
     */
    const id = typeof name === 'string' && name.length > 0 ? name : component.name;
    vue_1.default.component(id, component);
};
//# sourceMappingURL=helpers.js.map